<template>
  <div
    :class="`entryBtn${cantClick ? ' entryBtn_disabled':''}${showMessage ? ' entryBtn_showMessage':''}`"
    @click="click"
    @mouseenter="showActive(true)"
    @mouseleave="showActive(false)"
  >
    <!-- 未上線 -->
    <div v-if="data && !data.online && notOnline" class="notOnline entryBtn_warn_tips">
      <span>{{$t('message.notOnline1')}} {{data.onlineStartTime | formatDT}}{{data.onlineEndTime ? '-':''}}{{data.onlineEndTime | formatDT}} {{$t('message.notOnline2')}}</span>
    </div>
    <!-- 已下線 -->
    <div v-else-if="data && !data.online && data.onlineEndTime" class="offline entryBtn_warn_tips">
      <span>{{$t('message.offline')}}</span>
    </div>
    <!-- 維護中 -->
    <div v-else-if="data && data.maintenance" class="onMaintenance entryBtn_warn_tips">
      <span
        v-if="data.maintenanceEndTime"
      >{{$t('message.maintenance_tips1')}}{{$t('message.maintenance_tips2')}}{{data.maintenanceStartTime | formatDT}}-{{data.maintenanceEndTime | formatDT}} {{data[`message${$t('message.lan')}`]}}</span>
      <span v-else>{{$t('message.maintenance_tips1')}} {{data[`message${$t('message.lan')}`]}}</span>
    </div>
    <!-- 維護提示 -->
    <div v-else-if="data && data.showMaintenance" class="maintenance entryBtn_warn_tips">
      <span>{{$t('message.maintenance')}} {{data.maintenanceStartTime | formatDT}}{{data.maintenanceEndTime ? '-':''}}{{data.maintenanceEndTime | formatDT}} {{$t('message.maintenance2')}} {{data[`message${$t('message.lan')}`]}}</span>
    </div>
    <div class="entryBtn_icon">
      <img v-if="locale || isIE" :src="require(`../assets/${localIcon||'Circle.png'}`)" alt />
      <img v-if="!isIE && !locale" :src="`${icon}.png`" alt />
      <div
        v-if="data && data.maintenance"
        class="entryBtn_icon_tips"
      >{{$t('message.maintenance_img_tips')}}</div>
    </div>
    <div class="entryBtn_value">{{label}}</div>
  </div>
</template>

<script>
export default {
  props: [
    "icon",
    "label",
    "path",
    "disabled",
    "data",
    "locale",
    "localIcon",
    "year",
    "forAccountApp"
  ],
  data() {
    return {
      isIE: false,
      active: false,
    };
  },
  computed: {
    // 未上線
    notOnline() {
      const value = this.data;
      if (!value) return false;
      const date = new Date().getTime();
      const onlineStartTime = value.onlineStartTime
        ? new Date(value.onlineStartTime).getTime()
        : null;
      return onlineStartTime && onlineStartTime > date;
    },
    // 已下線
    offline() {
      const value = this.data;
      if (!value) return false;
      const date = new Date().getTime();
      const onlineEndTime =
        (value.onlineEndTime && new Date(value.onlineEndTime).getTime()) ||
        null;
      return onlineEndTime && onlineEndTime < date;
    },
    // 維護提示
    maintenance() {
      const value = this.data;
      if (!value) return false;
      const date = new Date().getTime();
      const maintenanceStartTime = value.maintenanceStartTime
        ? new Date(value.maintenanceStartTime).getTime()
        : null;
      return maintenanceStartTime && date < maintenanceStartTime;
    },
    // 維護中
    onMaintenance() {
      const value = this.data;
      if (!value) return false;
      const date = new Date().getTime();
      const maintenanceStartTime = value.maintenanceStartTime
        ? new Date(value.maintenanceStartTime).getTime()
        : null;
      const maintenanceEndTime = value.maintenanceEndTime
        ? new Date(value.maintenanceEndTime).getTime()
        : null;
      return (
        maintenanceStartTime &&
        (date >= maintenanceStartTime || date <= maintenanceEndTime)
      );
    },
    showMessage(){
      const data = this.data;
      const notOnline = this.notOnline;
      return (data && !data.online && notOnline) || (data && !data.online && data.onlineEndTime) || (data && data.maintenance) || (data && data.showMaintenance)
    },
    cantClick() {
      const data = this.data;
      return (
        this.disabled ||
        (data && !data.online) ||
        (data && !data.online && data.onlineEndTime) ||
        (data && data.maintenance)
      );
    },
  },
  methods: {
    showActive(bool) {
      this.active = bool;
    },
    click() {
      if (this.cantClick) {
        return;
      }
      this.$emit("click");
    },
  },
  created() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIE = true;
    } else {
      this.isIE = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.entryBtn {
  position: relative;
  width: 38%;
  background: rgba(255, 255, 255, 1);
  border-radius: 15px;
  border: 1px solid rgba(230, 229, 242, 0.81);
  padding: 22px 26px 18px 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
}
.entryBtn:hover {
  box-shadow: 0px 4px 8px 0px rgba(190, 193, 224, 0.32),
    0px 1px 18px 0px rgba(57, 169, 171, 1);
  .entryBtn_value {
    color: #38959d;
  }
}
.entryBtn_icon {
  min-width: 100px;
  position: relative;
  border-radius: 100px;
  overflow: hidden;
}
.entryBtn_icon img {
  width: 100%;
  display: block;
  margin: auto;
}
.entryBtn_value {
  margin-left: 5%;
  font-size: 24px;
  color: #666666;
  font-weight: 600;
  line-height: 33px;
  white-space: pre-wrap;
}
.entryBtn_disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.entryBtn_showMessage{
  padding-top: 50px !important;
}
.entryBtn_warn_tips {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 16px);
  // padding: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  z-index: 1;
  padding: 8px;
  text-align: center;
}
.entryBtn_warn_tips span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: center;
}
.onMaintenance {
  background: rgba(253, 238, 238, 1);
  color: rgba(242, 94, 94, 1);
}
.maintenance {
  background: rgba(253, 238, 238, 1);
  color: rgba(242, 94, 94, 1);
}
.notOnline {
  background: #edf2fc;
  color: #333;
  text-align: center;
}
.offline {
  background: #edf2fc;
  color: #333;
  text-align: center;
}
.entryBtn_icon_tips {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #f25d5d;
  color: #fff;
  font-size: 12px;
  height: 22px;
  line-height: 22px;
  text-align: center;
}
.entry_year {
  width: 29%;
  margin-left: 9%;
  img {
    width: 100%;
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .entryBtn {
    padding: 2% 3%;
    margin-left: 0 !important;
    width: 94%;
  }
  .entryBtn_value {
    font-size: 16px;
    line-height: 25px;
  }
  .entryBtn_icon {
    margin: 12px 0;
  }
  .entryBtn_icon img {
    width: 80px;
    height: 80px;
  }
}
</style>